import React from 'react'
import styles from "./section.module.css";

function Section({children, wide=false, shrink=false, small=false, ...props}) {
  return (
    <div {...props} className={`${styles.section} ${shrink ? styles.shrink : ''} ${small ? styles.small : ''}`}>
      <div className={wide ? styles.innerWide : styles.inner}>
        {children}
      </div>
    </div>
  )
}

export default Section